import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TextService {
  capitalizeFirstLetter(string) {
    if (!string) return string;
    if (string.includes('_')) string = string.split('_').join(' ');
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  capitalizeFirstLetterInEachWord(string) {
    return string
      .split(' ')
      .map(word => {
        const lowerWord = word.toLowerCase();
        if (lowerWord === 'nft') return lowerWord.toUpperCase();
        return this.capitalizeFirstLetter(lowerWord);
      })
      .join(' ');
  }

  createNameWithSpaces(name) {
    const pageName = name.replaceAll('-', ' ').replace(' and ', ' & ').replaceAll('_', ' ');
    const pageNameArray = pageName.split(' ');
    const capitalizedNameArray = pageNameArray.map(word => word.charAt(0).toUpperCase() + word.substring(1));
    return capitalizedNameArray.join(' ');
  }

  createNameWithSpaceAndCapitalizeFirstLetter(name) {
    if (!name) return;
    const capitalized = this.capitalizeFirstLetter(name);
    return this.createNameWithSpaces(capitalized);
  }

  hasSpacesAtStartOrEnd(text: string): boolean {
    return text.trim() !== text;
  }
}
